import React, { useEffect, useState } from 'react';
import { getTrips } from '../../../actions/trip-actions';
import { useDispatch, useSelector } from 'react-redux';
import { tripReducerSelector } from '../../../selector/trip-selectors';
import { TripsTable } from '../trip-table/trip-table.component'
import { Menu } from 'antd';
import { renderMenuContent } from './trips-root-module';
import { getBusDetailsAction } from '../../../actions/trip-create.actions';
import { getCityDetails } from '../../../actions/cities.actions';



export const TripsRoot = (props) => {

    const dispatch = useDispatch();
    const tripReducer = useSelector(tripReducerSelector);

    const [formData, updateformData] = useState({});
    const [current, setCurrent] = useState("tripDetails");

    useEffect(() => {
        dispatch(getTrips(global.travelsId));
        dispatch(getCityDetails(() => { }, () => { }))
        dispatch(getBusDetailsAction());
    }, []);

    const handleClick = (e) => {
        setCurrent(e.key);
    }

    return (
        <div>
            <TripsTable
                {...tripReducer}
                updateformData={updateformData}
                formData={formData}
            />
            <Menu onClick={handleClick} selectedKeys={[current]} mode="horizontal">
                <Menu.Item key="tripDetails" icon={null}>
                    Trip Details
                </Menu.Item>
                <Menu.Item key="routeDetails" icon={null}>
                    Route Details
                </Menu.Item>
                <Menu.Item key="boardingDetails" icon={null}>
                    Boarding Details
                </Menu.Item>
                <Menu.Item key="dropDetails" icon={null}>
                    Drop Details
                </Menu.Item>
            </Menu>
            {renderMenuContent(current, formData, updateformData)}
        </div>
    );
}
